module.exports = __webpack_public_path__ + "img/logo.2a7f3f89.svg";